module.exports = {
      id: "left-arrow-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#left-arrow",
      toString: function () {
        return this.url;
      }
    }